import * as Utils from './utils';

export async function TrimSaveAs(
	token: string,
	mediaId: number,
	start: string,
	end: string,
	newTitle: string | null,
) {
	try {
		await fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/trim/save-as/${mediaId}`, {
			method: 'POST',
			headers: Utils.getHeaders(token) as any,
			body: JSON.stringify({
				title: newTitle,
				startTimecode: start,
				endTimecode: end,
			}),
		});
	} catch (e) {
		return console.error(e);
	}
}

export async function TrimSaveOver(token: string, mediaId: number, start: string, end: string) {
	try {
		await fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/trim/save-over/${mediaId}`, {
			method: 'PUT',
			headers: Utils.getHeaders(token) as any,
			body: JSON.stringify({
				startTimecode: start,
				endTimecode: end,
			}),
		});
	} catch (e) {
		return console.error(e);
	}
}
